var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "cog-choice-image-container" },
    [
      _vm.option.svg
        ? _c("c-generated-avatar", { attrs: { svg: _vm.option.svg } })
        : _c("img", {
            class: _vm.getClasses,
            attrs: {
              srcset: !_vm.isSvgFileType ? _vm.getSrcSet : null,
              src: _vm.getSrc,
              alt: _vm.option.displayValue,
              width: _vm.getDimensions.width,
              height: _vm.getDimensions.height,
              loading: "lazy"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }